import { Link } from "react-router-dom";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-primary-100 border-t border-primary-200">
      <div className="w-full px-4 md:px-8 py-10 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-base">
                <i className="ri-flower-fill"></i>
              </span>
              <span className="font-heading text-lg font-semibold text-foreground-950">
                濑户环奈
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-xs">
              濑户环奈影视作品与最新动态资讯站，为粉丝提供详实的作品资料与及时的娱乐新闻。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">网站导航</h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/works" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  影视作品
                </Link>
              </li>
              <li>
                <Link to="/news" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  新闻动态
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  关于濑户环奈
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">关注我们</h4>
            <div className="flex items-center gap-3">
              <a
                href="https://www.instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50 text-foreground-700 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="https://www.youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50 text-foreground-700 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
              >
                <i className="ri-youtube-line text-lg"></i>
              </a>
              <a
                href="https://www.twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Twitter"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50 text-foreground-700 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
              >
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a
                href="https://www.weibo.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="微博"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50 text-foreground-700 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
              >
                <i className="ri-weibo-line text-lg"></i>
              </a>
            </div>
            <p className="text-xs text-foreground-500 mt-4 leading-relaxed">
              本站为粉丝资讯站点，所有作品与新闻内容均为示范数据，仅供展示。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © {year} 濑户环奈资讯站 · 内容均为示范数据，版权归原作者所有
          </p>
          <p className="text-xs text-foreground-500">
            本站与濑户环奈本人及其经纪公司无关联
          </p>
        </div>
      </div>
    </footer>
  );
}